import React from "react";
import "./LogoutConfirmation.css";

const LogoutConfirmation = ({ onConfirm, onCancel }) => {
  const handleOverlayClick = (e) => {
    if (e.target.className === "logout-confirmation-overlay") {
      onCancel();
    }
  };

  return (
    <div className="logout-confirmation-overlay" onClick={handleOverlayClick}>
      <div className="logout-confirmation-modal">
        <div className="logout-confirmation-header">
          <div className="logout-icon-large">🚪</div>
          <h2>Confirm Logout</h2>
        </div>

        <div className="logout-confirmation-content">
          <p>Are you sure you want to logout?</p>
          <p className="logout-warning">
            You will need to login again to access the application.
          </p>
        </div>

        <div className="logout-confirmation-actions">
          <button className="cancel-logout-btn" onClick={onCancel}>
            Cancel
          </button>

          <button className="confirm-logout-btn" onClick={onConfirm}>
            Yes, Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
